import { render, staticRenderFns } from "./TransactionListNew.vue?vue&type=template&id=2f52037a&scoped=true"
import script from "./TransactionListNew.vue?vue&type=script&lang=js"
export * from "./TransactionListNew.vue?vue&type=script&lang=js"
import style0 from "./TransactionListNew.vue?vue&type=style&index=0&id=2f52037a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52037a",
  null
  
)

export default component.exports